import { render, staticRenderFns } from "./AccesoDirecto.vue?vue&type=template&id=94ba9f02&scoped=true"
import script from "./AccesoDirecto.vue?vue&type=script&lang=js"
export * from "./AccesoDirecto.vue?vue&type=script&lang=js"
import style0 from "./AccesoDirecto.vue?vue&type=style&index=0&id=94ba9f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ba9f02",
  null
  
)

export default component.exports